/* ENLIY AirPresso – Kaufbereich: Galerie, Mengenauswahl (Festpreis-Bundles), Varianten,
   Willkommensrabatt, Bewertungs-Karussell, Lieferzeit, mobile Kurzbeschreibung.
   Warenkorb-Submit laeuft ueber ap-theme.js ([data-ap-add-form]). */
(function () {
  'use strict';

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  /* Preise im Format der aktuellen Marktwaehrung (z. B. 59,95 EUR oder $59.95).
     Vorlage ist ein von Shopify formatierter Beispielbetrag (ApTheme.moneySample = 123456 Cent). */
  function money(cents) {
    cents = Math.round(Number(cents) || 0);
    var cfg = window.ApTheme || {};
    var sample = cfg.moneySample || '';
    var m = sample.match(/\d(?:[\d.,'’\s  ]*\d)?/);
    if (m) {
      var num = m[0], digits = num.replace(/\D/g, '');
      var dec = 0, ds = '', th = '';
      if (digits === '123456') {
        dec = 2; ds = num.charAt(num.length - 3);
        var intPart = num.slice(0, num.length - 3);
        th = intPart.length > 4 ? intPart.charAt(1) : '';
      } else {
        dec = 0; th = num.length > 4 ? num.charAt(1) : '';
      }
      var val = (cents / 100).toFixed(dec).split('.');
      var ip = val[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      var out = dec ? ip + ds + val[1] : ip;
      return sample.slice(0, m.index) + out + sample.slice(m.index + num.length);
    }
    var f = cfg.moneyFormat || '{{amount_with_comma_separator}}';
    function sep(n, d, t, s2) {
      var parts = (n / 100).toFixed(d).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, t);
      return parts.join(s2);
    }
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (x, k) {
      switch (k) {
        case 'amount': return sep(cents, 2, ',', '.');
        case 'amount_no_decimals': return sep(cents, 0, ',', '.');
        case 'amount_no_decimals_with_comma_separator': return sep(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return sep(cents, 2, "'", '.');
        default: return sep(cents, 2, '.', ',');
      }
    });
  }
  function str(k, fb) { var s = window.ApTheme && window.ApTheme.strings; return (s && s[k]) || fb; }
  function dateLocale() { var l = (window.ApTheme && window.ApTheme.locale) || 'de'; return l === 'en' ? 'en-US' : (l.indexOf('-') > 0 ? l : l + '-' + l.toUpperCase()); }

  function initGallery(root) {
    var track = $('[data-lp-gal-track]', root);
    if (!track || track.__lp) return;
    track.__lp = true;
    var slides = $$('[data-lp-gal-slide]', track);
    var thumbs = $$('[data-lp-gal-thumb]', root);
    var count = $('[data-lp-gal-count]', root);
    var prev = $('[data-lp-gal-prev]', root);
    var next = $('[data-lp-gal-next]', root);
    var current = 0;
    function setActive(i) {
      current = i;
      thumbs.forEach(function (t, n) {
        var on = n === i;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-current', on ? 'true' : 'false');
      });
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
      var th = thumbs[i];
      if (th && th.parentNode.scrollWidth > th.parentNode.clientWidth) {
        th.parentNode.scrollLeft = th.offsetLeft - th.parentNode.clientWidth / 2 + th.clientWidth / 2;
      }
    }
    var settle = null;
    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      var target = track.clientWidth * i;
      track.scrollTo({ left: target, behavior: 'smooth' });
      setActive(i);
      clearTimeout(settle);
      settle = setTimeout(function () {
        if (Math.abs(track.scrollLeft - target) > 2) {
          track.style.scrollBehavior = 'auto';
          track.scrollLeft = target;
          track.style.scrollBehavior = '';
        }
      }, 700);
    }
    var t = null;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i !== current) setActive(i);
      }, 60);
    }, { passive: true });
    thumbs.forEach(function (th, i) { th.addEventListener('click', function () { go(i); }); });
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
    });
    window.addEventListener('resize', function () {
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = track.clientWidth * current;
      track.style.scrollBehavior = '';
    });
    setActive(0);
  }

  function initDesc(root) {
    var desc = $('.lp-pdp-desc', root);
    if (!desc || desc.__lp) return;
    desc.__lp = true;
    if ((desc.textContent || '').trim().length < 90) return;
    if (!desc.id) desc.id = 'lp-pdp-desc-' + Math.random().toString(36).slice(2, 8);
    desc.classList.add('is-clamped');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'lp-desc-toggle';
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', desc.id);
    btn.textContent = str('more', 'Mehr lesen');
    btn.addEventListener('click', function () {
      var open = desc.classList.toggle('is-clamped') === false;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? str('less', 'Weniger anzeigen') : str('more', 'Mehr lesen');
    });
    desc.parentNode.insertBefore(btn, desc.nextSibling);
  }

  function initBuy(root) {
    var form = $('#lp-buy-form', root);
    if (!form || form.__lp) return;
    form.__lp = true;
    var qtyInput = $('[data-ap-quantity-input]', form);
    var varInput = $('[data-ap-variant-input]', form);
    var addBtn = $('[data-ap-add-button]', form);
    var bundles = $$('[data-lp-bundle]', form);
    var opts = $$('[data-lp-variant]', form);
    var unit = Number(form.getAttribute('data-unit-price')) || 0;
    var baseVariant = form.getAttribute('data-base-variant') || (varInput ? varInput.value : '');
    var stickyPrice = $('[data-lp-sticky] .lp-sticky-price');
    var priceEl = $('[data-lp-price]', root);
    var preview = form.hasAttribute('data-lp-preview');
    var stickyBtn = $('[data-lp-sticky] button');
    if (preview && stickyBtn) stickyBtn.disabled = true;
    function selected() {
      for (var i = 0; i < bundles.length; i++) if (bundles[i].checked) return bundles[i];
      return null;
    }
    function totals(b) {
      var qty = b ? Number(b.getAttribute('data-qty')) || 1 : 1;
      if (b && b.hasAttribute('data-variant')) {
        var total = Number(b.getAttribute('data-total')) || 0;
        var full = Number(b.getAttribute('data-full')) || unit * qty;
        return { qty: qty, formQty: Number(b.getAttribute('data-form-qty')) || 1, variant: b.getAttribute('data-variant'), full: full, total: total, disc: Math.max(0, full - total), fixed: true };
      }
      var pct = b ? Number(b.getAttribute('data-pct')) || 0 : 0;
      var f = unit * qty;
      var disc = Math.floor((f * pct + 50) / 100);
      return { qty: qty, formQty: qty, variant: baseVariant, full: f, total: f - disc, disc: disc, fixed: false };
    }
    function renderCards() {
      bundles.forEach(function (b) {
        if (b.hasAttribute('data-variant')) return;
        var tt = totals(b);
        var label = b.closest('.lp-bundle');
        if (!label) return;
        var p = $('[data-lp-bundle-total]', label);
        var s = $('[data-lp-bundle-full]', label);
        if (unit > 0) {
          if (p) p.textContent = money(tt.total);
          if (s) s.textContent = tt.disc > 0 ? money(tt.full) : '';
        }
      });
    }
    function update() {
      var b = selected();
      var tt = totals(b);
      if (qtyInput) qtyInput.value = String(tt.formQty);
      if (varInput && tt.variant) varInput.value = String(tt.variant);
      if (addBtn && b) addBtn.disabled = preview || b.hasAttribute('data-unavailable') || !(unit > 0);
      bundles.forEach(function (x) {
        var l = x.closest('.lp-bundle');
        if (l) l.classList.toggle('is-active', x.checked);
      });
      if (stickyPrice && unit > 0) {
        var ship = str('stickyShip', '');
        stickyPrice.textContent = (tt.qty > 1 ? str('units', '__Q__ Stück').replace('__Q__', tt.qty) + ' · ' : '') + money(tt.total) + (ship ? ' · ' + ship : '');
      }
    }
    bundles.forEach(function (b) { b.addEventListener('change', update); });
    opts.forEach(function (o) {
      o.addEventListener('click', function () {
        if (o.disabled) return;
        opts.forEach(function (x) { x.classList.toggle('is-active', x === o); x.setAttribute('aria-pressed', x === o ? 'true' : 'false'); });
        baseVariant = o.getAttribute('data-lp-variant');
        unit = Number(o.getAttribute('data-price')) || unit;
        form.setAttribute('data-unit-price', String(unit));
        if (priceEl && unit > 0) priceEl.textContent = money(unit);
        renderCards();
        update();
      });
    });
    renderCards();
    update();
  }

  function initFirstOrder(root) {
    var box = $('[data-lp-fo]', root);
    if (!box || box.__lp) return;
    box.__lp = true;
    var code = box.getAttribute('data-code') || '';
    var status = $('[data-lp-fo-status]', box);
    var timer = null;
    function say(t, keep) {
      if (!status) return;
      status.textContent = t;
      clearTimeout(timer);
      if (!keep) timer = setTimeout(function () { status.textContent = ''; }, 4000);
    }
    function fallbackCopy(text) {
      var ta = document.createElement('textarea');
      ta.value = text; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select();
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta);
      return ok;
    }
    var copyBtn = $('[data-lp-fo-copy]', box);
    if (copyBtn) copyBtn.addEventListener('click', function () {
      var done = function () { say(str('copied', 'Code kopiert!')); copyBtn.classList.add('is-copied'); setTimeout(function () { copyBtn.classList.remove('is-copied'); }, 2000); };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done, function () { fallbackCopy(code) ? done() : say(str('yourCode', 'Dein Code:') + ' ' + code, true); });
      } else { fallbackCopy(code) ? done() : say(str('yourCode', 'Dein Code:') + ' ' + code, true); }
    });
    var applyBtn = $('[data-lp-fo-apply]', box);
    if (applyBtn) applyBtn.addEventListener('click', function () {
      applyBtn.disabled = true;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ discount: code })
      }).then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          fetch(root + 'discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {});
          var list = cart && cart.discount_codes ? cart.discount_codes : [];
          var hit = null;
          for (var i = 0; i < list.length; i++) if (String(list[i].code).toUpperCase() === code.toUpperCase()) hit = list[i];
          if (hit && hit.applicable) say(str('applied', 'Code angewendet.'), true);
          else if (cart && cart.item_count === 0) say(str('savedEmpty', 'Code ist vorgemerkt.'), true);
          else say(str('saved', 'Code ist vorgemerkt.'), true);
          document.dispatchEvent(new CustomEvent('lp:discount-applied', { detail: { code: code, cart: cart } }));
        })
        .catch(function () { say(str('atCheckout', 'Bitte den Code im Checkout eingeben:') + ' ' + code, true); applyBtn.disabled = false; });
    });
  }

  function initReviews(root) {
    var rv = $('[data-lp-rv]', root);
    if (!rv || rv.__lp) return;
    rv.__lp = true;
    var track = $('[data-lp-rv-track]', rv);
    function step(d) { track.scrollBy({ left: d * track.clientWidth, behavior: 'smooth' }); }
    var p = $('[data-lp-rv-prev]', rv), n = $('[data-lp-rv-next]', rv);
    if (p) p.addEventListener('click', function () { step(-1); });
    if (n) n.addEventListener('click', function () { step(1); });
  }

  function addBusinessDays(d, n) {
    var r = new Date(d.getTime());
    while (n > 0) {
      r.setDate(r.getDate() + 1);
      var wd = r.getDay();
      if (wd !== 0 && wd !== 6) n--;
    }
    return r;
  }
  function fmtDate(d) {
    try { return d.toLocaleDateString(dateLocale(), { weekday: 'short', day: '2-digit', month: '2-digit' }); }
    catch (e) { return d.getDate() + '.' + (d.getMonth() + 1) + '.'; }
  }
  function initDelivery(root) {
    var el = $('[data-lp-deliv]', root);
    if (!el || el.__lp) return;
    el.__lp = true;
    var a = ['h-min', 'h-max', 't-min', 't-max'].map(function (k) { return el.getAttribute('data-' + k); });
    var ok = a.every(function (x) { return x !== null && x !== '' && !isNaN(Number(x)); });
    if (!ok) return;
    var n = a.map(Number);
    var now = new Date();
    var cutoff = el.getAttribute('data-cutoff');
    var base = new Date(now.getTime());
    if (cutoff !== null && cutoff !== '' && now.getHours() >= Number(cutoff)) base = addBusinessDays(base, 1);
    var s1 = addBusinessDays(base, n[0]), s2 = addBusinessDays(base, n[1]);
    var d1 = addBusinessDays(s1, n[2]), d2 = addBusinessDays(s2, n[3]);
    var e1 = $('[data-lp-deliv-d1]', el), e2 = $('[data-lp-deliv-d2]', el);
    if (e1) e1.textContent = n[0] === n[1] ? fmtDate(s1) : fmtDate(s1) + ' – ' + fmtDate(s2);
    if (e2) e2.textContent = fmtDate(d1) + ' – ' + fmtDate(d2);
  }

  function initAll(scope) {
    var roots = $$('[data-lp-pdp]', scope || document);
    roots.forEach(function (r) { initGallery(r); initDesc(r); initBuy(r); initFirstOrder(r); initReviews(r); initDelivery(r); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
